import { render, staticRenderFns } from "./incomePlanDetail.vue?vue&type=template&id=568e6dca&scoped=true"
import script from "./incomePlanDetail.vue?vue&type=script&lang=js"
export * from "./incomePlanDetail.vue?vue&type=script&lang=js"
import style0 from "./incomePlanDetail.vue?vue&type=style&index=0&id=568e6dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568e6dca",
  null
  
)

export default component.exports